import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconPriceTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.3636 10.2619C17.3718 10.2619 18.1891 9.44457 18.1891 8.43636C18.1891 7.42815 17.3718 6.61084 16.3636 6.61084C15.3554 6.61084 14.5381 7.42815 14.5381 8.43636C14.5381 9.44457 15.3554 10.2619 16.3636 10.2619Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.9239 15.0762C2.53338 14.6857 2.53338 14.0526 2.9239 13.662L13.1699 3.41602H21.3848V11.6309L11.1387 21.8769C10.7482 22.2674 10.1151 22.2674 9.72453 21.8769L2.9239 15.0762Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export { IconPriceTag };